import type { Questionnaire } from '@medplum/fhirtypes'

export const ServiceAllocationQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/demographics-service-allocation',
  status: 'draft',
  subjectType: ['Patient'],
  name: 'Service Allocation Demographics',
  title: 'Service Allocation',
  item: [
    {
      linkId: 'day-center-attendance',
      text: 'Day Center Attendance',
      type: 'text',
    },
    {
      linkId: 'transportation-requirements',
      text: 'Transportation Requirements',
      type: 'text',
    },
    {
      linkId: 'escort-requirements',
      text: 'Escort Requirements',
      type: 'text',
    },
    {
      linkId: 'interpreter-requirements',
      text: 'Interpreter Requirements',
      type: 'text',
    },
    {
      linkId: 'ability-to-live-safely-in-community',
      text: 'Can the participant live safely in community?',
      type: 'text',
    },
    {
      linkId: 'home-environment-safe',
      text: 'Is the home environment safe?',
      type: 'boolean',
    },
  ] as const,
} satisfies Questionnaire
